<template>
  <div class="content">
    <el-form
      class="form-box"
      :model="form"
      label-width="90px"
      label-position="left"
      v-loading="cashLoading"
    >
      <div class="top">
        <p>
          红包现金比例设置；按此设置自动将商品售价换算成红包兑换数，不设置默认1:1兑换
        </p>
        <el-button type="primary" @click="onSaveSetting(0)">保存设置</el-button>
      </div>
      <el-form-item label="人民币1元=">
        <el-input
          class="input-hb"
          size="mini"
          v-model="form.rmb_convert_red_packet_rate"
          type="number"
          min="0"
        ></el-input
        ><span class="tip"
          >最小数值为1且保留整数，设置为0无效</span
        ></el-form-item
      ></el-form
    >
    <el-form
      class="form-box"
      :model="form"
      label-width="90px"
      label-position="left"
      v-loading="discountLoading"
    >
      <div class="top">
        <p>
          剩余红包不足现金抵扣设置：红包余额不足时按此设置自动折算成需要支付的剩余现金额，不设置默认1:1折算
        </p>
        <el-button type="primary" @click="onSaveSetting(1)">保存设置</el-button>
      </div>
      <el-form-item label="红包1元=">
        <el-input
          class="input-cash"
          size="mini"
          v-model="form.red_packet_convert_rmb_rate"
          type="number"
          min="0"
        ></el-input
        ><span style="margin-left: 6px">人民币</span
        ><span class="tip">设置为0无效</span></el-form-item
      ></el-form
    >
    <el-form
      class="form-box"
      :model="form"
      label-width="90px"
      label-position="left"
      v-loading="freightLoading"
    >
      <div class="top">
        <p>商品运费红包现金比例，不设置默认1:1兑换</p>
        <el-button type="primary" @click="onSaveSetting(2)">保存设置</el-button>
      </div>
      <el-form-item label="人民币1元=">
        <el-input
          class="input-cash"
          size="mini"
          v-model="form.rmb_convert_freight_amount_rate"
          type="number"
          min="0"
        ></el-input
        ><span style="margin-left: 6px">红包</span
        ><span class="tip">最小数值为1</span></el-form-item
      ></el-form
    >
  </div>
</template>

<script>
import {
  setRedpacketExchangeSetting,
  getRedpacketExchangeSetting,
} from '@/api/redpacket'
export default {
  data() {
    return {
      cashLoading: false,
      discountLoading: false,
      freightLoading: false,
      form: {
        rmb_convert_red_packet_rate: 0,
        red_packet_convert_rmb_rate: 0,
        rmb_convert_freight_amount_rate: 0,
      },
      data: null,
    }
  },
  created() {
    this.cashLoading = true
    this.discountLoading = true
    this.freightLoading = true
    getRedpacketExchangeSetting().then((res) => {
      this.cashLoading = false
      this.discountLoading = false
      this.freightLoading = false
      this.data = res.data
      this.form.rmb_convert_red_packet_rate =
        res.data.rmb_convert_red_packet_rate
      this.form.red_packet_convert_rmb_rate =
        res.data.red_packet_convert_rmb_rate
      this.form.rmb_convert_freight_amount_rate =
        res.data.rmb_convert_freight_amount_rate
    })
  },
  methods: {
    onSaveSetting(index) {
      if (index === 0) {
        this.cashLoading = true
        setRedpacketExchangeSetting({
          rmb_convert_red_packet_rate: this.form.rmb_convert_red_packet_rate,
          red_packet_convert_rmb_rate: this.data.red_packet_convert_rmb_rate,
          rmb_convert_freight_amount_rate:
            this.data.rmb_convert_freight_amount_rate,
        }).then(() => {
          this.data.rmb_convert_red_packet_rate =
            this.form.rmb_convert_red_packet_rate
          this.cashLoading = false
        })
      } else if (index === 1) {
        this.discountLoading = true
        setRedpacketExchangeSetting({
          rmb_convert_red_packet_rate: this.data.rmb_convert_red_packet_rate,
          red_packet_convert_rmb_rate: this.form.red_packet_convert_rmb_rate,
          rmb_convert_freight_amount_rate:
            this.data.rmb_convert_freight_amount_rate,
        }).then(() => {
          this.data.red_packet_convert_rmb_rate =
            this.form.red_packet_convert_rmb_rate
          this.discountLoading = false
        })
      } else {
        this.freightLoading = true
        setRedpacketExchangeSetting({
          rmb_convert_red_packet_rate: this.data.rmb_convert_red_packet_rate,
          red_packet_convert_rmb_rate: this.data.red_packet_convert_rmb_rate,
          rmb_convert_freight_amount_rate:
            this.form.rmb_convert_freight_amount_rate,
        }).then(() => {
          this.data.rmb_convert_freight_amount_rate =
            this.form.rmb_convert_freight_amount_rate
          this.freightLoading = false
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  .form-box {
    background-color: #e0e0e0;
    padding: 20px;
    margin-bottom: 16px;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    ::v-deeplabel {
      color: #333;
    }
    .input-cash {
      width: 100px;
    }
    .input-hb {
      position: relative;
      width: 160px;
      box-sizing: border-box;

      ::v-deepinput {
        padding-right: 32px;
      }
      &::after {
        content: '红包';
        position: absolute;
        top: 50%;
        right: 4px;
        transform: translateY(-50%);
      }
    }
    .tip {
      background-color: orange;
      margin-left: 12px;
      color: #fff;
      padding: 2px 6px;
      border-radius: 4px;
      font-size: 12px;
    }
  }
}
</style>
